export const CATEGORIES = [
  {
    id: 10001,
    name: 'Kinh doanh / Bán hàng',
    alias: 'kinh-doanh-ban-hang',
  },
  {
    id: 10003,
    name: 'Biên / Phiên dịch',
    alias: 'bien-phien-dich',
  },
  {
    id: 10004,
    name: 'Báo chí / Truyền hình',
    alias: 'bao-chi-truyen-hinh',
  },
  {
    id: 10005,
    name: 'Bưu chính - Viễn thông',
    alias: 'buu-chinh-vien-thong',
  },
  {
    id: 10006,
    name: 'Bảo hiểm',
    alias: 'bao-hiem',
  },
  {
    id: 10007,
    name: 'Bất động sản',
    alias: 'bat-dong-san',
  },
  {
    id: 10008,
    name: 'Chứng khoán / Vàng / Ngoại tệ',
    alias: 'chung-khoan-vang-ngoai-te',
  },
  {
    id: 10009,
    name: 'Công nghệ cao',
    alias: 'cong-nghe-cao',
  },
  {
    id: 10010,
    name: 'Cơ khí / Chế tạo / Tự động hóa',
    alias: 'co-khi-che-tao-tu-dong-hoa',
  },
  {
    id: 10011,
    name: 'Du lịch',
    alias: 'du-lich',
  },
  {
    id: 10012,
    name: 'Dầu khí/Hóa chất',
    alias: 'dau-khi-hoa-chat',
  },
  {
    id: 10013,
    name: 'Dệt may / Da giày',
    alias: 'det-may-da-giay',
  },
  {
    id: 10014,
    name: 'Dịch vụ khách hàng',
    alias: 'dich-vu-khach-hang',
  },
  {
    id: 10015,
    name: 'Điện tử viễn thông',
    alias: 'dien-tu-vien-thong',
  },
  {
    id: 10016,
    name: 'Điện / Điện tử / Điện lạnh',
    alias: 'dien-dien-tu-dien-lanh',
  },
  {
    id: 10017,
    name: 'Giáo dục / Đào tạo',
    alias: 'giao-duc-dao-tao',
  },
  {
    id: 10018,
    name: 'Hoá học / Sinh học',
    alias: 'hoa-hoc-sinh-hoc',
  },
  {
    id: 10019,
    name: 'Hoạch định/Dự án',
    alias: 'hoach-dinh-du-an',
  },
  {
    id: 10020,
    name: 'Hàng gia dụng',
    alias: 'hang-gia-dung',
  },
  {
    id: 10021,
    name: 'Hàng hải',
    alias: 'hang-hai',
  },
  {
    id: 10022,
    name: 'Hàng không',
    alias: 'hang-khong',
  },
  {
    id: 10023,
    name: 'Hành chính / Văn phòng',
    alias: 'hanh-chinh-van-phong',
  },
  {
    id: 10024,
    name: 'In ấn / Xuất bản',
    alias: 'in-an-xuat-ban',
  },
  {
    id: 10025,
    name: 'IT Phần cứng / Mạng',
    alias: 'it-phan-cung-mang',
  },
  {
    id: 10026,
    name: 'IT phần mềm',
    alias: 'it-phan-mem',
  },
  {
    id: 10027,
    name: 'Khách sạn / Nhà hàng',
    alias: 'khach-san-nha-hang',
  },
  {
    id: 10028,
    name: 'Kế toán / Kiểm toán',
    alias: 'ke-toan-kiem-toan',
  },
  {
    id: 10029,
    name: 'Marketing / Truyền thông / Quảng cáo',
    alias: 'marketing-truyen-thong-quang-cao',
  },
  {
    id: 10030,
    name: 'Môi trường / Xử lý chất thải',
    alias: 'moi-truong-xu-ly-chat-thai',
  },
  {
    id: 10031,
    name: 'Mỹ phẩm / Trang sức',
    alias: 'my-pham-trang-suc',
  },
  {
    id: 10032,
    name: 'Mỹ thuật / Nghệ thuật / Điện ảnh',
    alias: 'my-thuat-nghe-thuat-dien-anh',
  },
  {
    id: 10033,
    name: 'Ngân hàng / Tài chính',
    alias: 'ngan-hang-tai-chinh',
  },
  {
    id: 10034,
    name: 'Nhân sự',
    alias: 'nhan-su',
  },
  {
    id: 10035,
    name: 'Nông / Lâm / Ngư nghiệp',
    alias: 'nong-lam-ngu-nghiep',
  },
  {
    id: 10036,
    name: 'Luật/Pháp lý',
    alias: 'luat-phap-ly',
  },
  {
    id: 10037,
    name: 'Quản lý chất lượng (QA/QC)',
    alias: 'quan-ly-chat-luong-qa-qc',
  },
  {
    id: 10038,
    name: 'Quản lý điều hành',
    alias: 'quan-ly-dieu-hanh',
  },
  {
    id: 10039,
    name: 'Thiết kế đồ họa',
    alias: 'thiet-ke-do-hoa',
  },
  {
    id: 10042,
    name: 'Thời trang',
    alias: 'thoi-trang',
  },
  {
    id: 10043,
    name: 'Thực phẩm / Đồ uống',
    alias: 'thuc-pham-do-uong',
  },
  {
    id: 10045,
    name: 'Tư vấn',
    alias: 'tu-van',
  },
  {
    id: 10046,
    name: 'Tổ chức sự kiện / Quà tặng',
    alias: 'to-chuc-su-kien-qua-tang',
  },
  {
    id: 10047,
    name: 'Vận tải / Kho vận',
    alias: 'van-tai-kho-van',
  },
  {
    id: 10048,
    name: 'Logistics',
    alias: 'logistics',
  },
  {
    id: 10049,
    name: 'Xuất nhập khẩu',
    alias: 'xuat-nhap-khau',
  },
  {
    id: 10050,
    name: 'Xây dựng',
    alias: 'xay-dung',
  },
  {
    id: 10051,
    name: 'Y tế / Dược',
    alias: 'y-te-duoc',
  },
  {
    id: 10052,
    name: 'Công nghệ Ô tô',
    alias: 'cong-nghe-o-to',
  },
  {
    id: 10101,
    name: 'An toàn lao động',
    alias: 'an-toan-lao-dong',
  },
  {
    id: 10102,
    name: 'Bán hàng kỹ thuật',
    alias: 'ban-hang-ky-thuat',
  },
  {
    id: 10103,
    name: 'Bán lẻ / bán sỉ',
    alias: 'ban-le-ban-si',
  },
  {
    id: 10104,
    name: 'Bảo trì / Sữa chữa',
    alias: 'bao-tri-sua-chua',
  },
  {
    id: 10110,
    name: 'Dược phẩm / Công nghệ sinh học',
    alias: 'duoc-pham-cong-nghe-sinh-hoc',
  },
  {
    id: 10111,
    name: 'Địa chất / Khoáng sản',
    alias: 'dia-chat-khoang-san',
  },
  {
    id: 10113,
    name: 'Hàng cao cấp',
    alias: 'hang-cao-cap',
  },
  {
    id: 10117,
    name: 'Hàng tiêu dùng',
    alias: 'hang-tieu-dung',
  },
  {
    id: 10120,
    name: 'Kiến trúc',
    alias: 'kien-truc',
  },
  {
    id: 10124,
    name: 'Phi chính phủ / Phi lợi nhuận',
    alias: 'phi-chinh-phu-phi-loi-nhuan',
  },
  {
    id: 10125,
    name: 'Sản phẩm công nghiệp',
    alias: 'san-pham-cong-nghiep',
  },
  {
    id: 10126,
    name: 'Sản xuất',
    alias: 'san-xuat',
  },
  {
    id: 10127,
    name: 'Tài chính / Đầu tư',
    alias: 'tai-chinh-dau-tu',
  },
  {
    id: 10128,
    name: 'Thiết kế nội thất',
    alias: 'thiet-ke-noi-that',
  },
  {
    id: 10129,
    name: 'Thư ký / Trợ lý',
    alias: 'thu-ky-tro-ly',
  },
  {
    id: 10130,
    name: 'Spa / Làm đẹp',
    alias: 'spa-lam-dep',
  },
  {
    id: 10131,
    name: 'Công nghệ thông tin',
    alias: 'cong-nghe-thong-tin',
  },
  {
    id: 10132,
    name: 'NGO / Phi chính phủ / Phi lợi nhuận',
    alias: 'ngo-phi-chinh-phu-phi-loi-nhuan',
  },
  {
    id: 11000,
    name: 'Ngành nghề khác',
    alias: 'nganh-nghe-khac',
  },
];
